import React from 'react'

import * as ReactDOM from 'react-dom'

class OverlayPortalModal extends React.Component {
  constructor(props) {
    super(props)
    this.portalContainer = document.getElementById('overlay-portal')
    this.el = document.createElement('div')
  }

  componentDidMount() {
    this.portalContainer.appendChild(this.el)
  }

  componentWillUnmount() {
    this.portalContainer.removeChild(this.el)
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el)
  }
}

export default OverlayPortalModal
